function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import isEmpty from 'lodash/isEmpty';
import findKey from 'lodash/findKey';
import gettext from 'js-utils/gettext';
import classNames from 'classnames';
import { Link } from 'react-router';
import * as constants from './constants';
import { getNarrowMenuInfo } from './utils';
import { ROUTER_LINK } from '../navListItem/constants';
import { ICON_TYPE_PROP_TYPE, COLOR_PROP_TYPE } from '../icon/constants';
import { TEXT_ITEMS_PROP_TYPE } from '../textList/constants';
import { TYPE_SEARCH as TEXT_INPUT_TYPE_SEARCH } from '../textInput/constants';
import { ALIGN_FULL, ALIGN_RIGHT } from '../containers/dropdown/constants';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import AutocompleteField from '../autocompleteField/AutocompleteField';
import FormField from '../formField/FormField';
import Dropdown from '../containers/dropdown/Dropdown';
import DropdownMenu from '../dropdownMenu/DropdownMenu';
import Avatar from '../avatar/Avatar';
import MagnifyingGlassChunkySvg from '../iconography/icons/MagnifyingGlassChunky';
import UserChunkySvg from '../iconography/icons/UserChunky';

var GlobalHeaderLogo = function GlobalHeaderLogo(_ref) {
  var _classNames;

  var info = _ref.info;

  var url = info.url,
      _info$iconType = info.iconType,
      iconType = _info$iconType === void 0 ? constants.DEFAULT_LOGO_TYPE : _info$iconType,
      _info$iconColor = info.iconColor,
      iconColor = _info$iconColor === void 0 ? constants.DEFAULT_LOGO_COLOR : _info$iconColor,
      _info$iconTitle = info.iconTitle,
      iconTitle = _info$iconTitle === void 0 ? constants.DEFAULT_LOGO_TITLE : _info$iconTitle,
      _info$iconWidth = info.iconWidth,
      iconWidth = _info$iconWidth === void 0 ? constants.DEFAULT_LOGO_SIZE.width : _info$iconWidth,
      _info$iconHeight = info.iconHeight,
      iconHeight = _info$iconHeight === void 0 ? constants.DEFAULT_LOGO_SIZE.height : _info$iconHeight,
      backgroundColor = info.backgroundColor,
      shouldUseSpecialWidth = info.shouldUseSpecialWidth,
      linkProps = _objectWithoutProperties(info, ["url", "iconType", "iconColor", "iconTitle", "iconWidth", "iconHeight", "backgroundColor", "shouldUseSpecialWidth"]);

  var className = classNames('eds-global-header__logo-link', (_classNames = {}, _defineProperty(_classNames, "eds-bg-color--".concat(backgroundColor), backgroundColor), _defineProperty(_classNames, 'eds-global-header--logo-special-width', !!shouldUseSpecialWidth), _classNames));
  return React.createElement("a", _extends({
    href: url,
    className: className,
    "data-spec": "global-header-logo-link"
  }, linkProps), React.createElement(Icon, {
    type: iconType,
    color: iconColor,
    title: iconTitle,
    isBlockLevel: true,
    height: iconHeight,
    width: iconWidth,
    "data-spec": "global-header-logo"
  }));
};

var GlobalHeaderSearchForm = function GlobalHeaderSearchForm(_ref2) {
  var searchInfo = _ref2.searchInfo,
      id = _ref2.id,
      className = _ref2.className,
      hideIcon = _ref2.hideIcon,
      onSelect = _ref2.onSelect,
      onSubmit = _ref2.onSubmit,
      onChange = _ref2.onChange,
      onBlur = _ref2.onBlur,
      onFocus = _ref2.onFocus,
      isLimitedSearch = _ref2.isLimitedSearch;
  var formAction = searchInfo.formAction,
      label = searchInfo.label,
      _searchInfo$fieldName = searchInfo.fieldName,
      fieldName = _searchInfo$fieldName === void 0 ? constants.DEFAULT_SEARCH_FIELD_NAME : _searchInfo$fieldName,
      _searchInfo$query = searchInfo.query,
      query = _searchInfo$query === void 0 ? '' : _searchInfo$query,
      _searchInfo$suggestio = searchInfo.suggestions,
      suggestions = _searchInfo$suggestio === void 0 ? [] : _searchInfo$suggestio,
      _searchInfo$formMetho = searchInfo.formMethod,
      formMethod = _searchInfo$formMetho === void 0 ? constants.DEFAULT_SEARCH_METHOD : _searchInfo$formMetho;
  var autocompleteId = "".concat(id, "-autocomplete");
  var autocompleteIcon;

  if (!hideIcon) {
    autocompleteIcon = React.createElement(Icon, {
      type: React.createElement(MagnifyingGlassChunkySvg, null),
      size: "small",
      color: "grey-500"
    });
  }

  var form = React.createElement(FormField, {
    label: label,
    htmlFor: autocompleteId,
    hideLabel: true,
    bottomSpacing: 0
  }, React.createElement(AutocompleteField, {
    id: autocompleteId,
    type: TEXT_INPUT_TYPE_SEARCH,
    name: fieldName,
    value: query,
    suggestions: suggestions,
    placeholder: label,
    "data-automation": "search-input",
    onSelect: onSelect,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    hideOutline: !hideIcon,
    isLimitedSearch: isLimitedSearch
  }, autocompleteIcon));

  if (formAction || onSubmit) {
    var handleFormSubmit = function handleFormSubmit(e) {
      // NOTE: If `onSubmit` is defined, we want to handle the form submission
      // in JavaScript, so we should prevent the default browser submission.
      // However, if `onSubmit` is not defined, we want to allow the default
      // broswer submission to happen.
      if (onSubmit) {
        e.preventDefault();
        onSubmit(query);
      }
    };

    form = React.createElement("form", {
      "data-spec": "global-header-search-form",
      action: formAction,
      method: formMethod,
      id: id,
      onSubmit: handleFormSubmit
    }, form, React.createElement("input", {
      type: "hidden",
      name: "mode",
      value: "search"
    }));
  }

  return React.createElement("div", {
    className: className
  }, form);
};

var GlobalHeaderSearchDropdown = function GlobalHeaderSearchDropdown(_ref3) {
  var show = _ref3.show,
      searchInfo = _ref3.searchInfo,
      id = _ref3.id,
      onHide = _ref3.onHide,
      onSelect = _ref3.onSelect,
      onSubmit = _ref3.onSubmit,
      onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      onFocus = _ref3.onFocus,
      isLimitedSearch = _ref3.isLimitedSearch;

  if (!show || !searchInfo) {
    return null;
  }

  return React.createElement(Dropdown, {
    align: ALIGN_FULL,
    onClickOutside: onHide
  }, React.createElement(GlobalHeaderSearchForm, {
    searchInfo: searchInfo,
    id: id,
    hideIcon: true,
    onSelect: onSelect,
    onSubmit: onSubmit,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    isLimitedSearch: isLimitedSearch
  }));
};

var GlobalHeaderSearch = function GlobalHeaderSearch(_ref4) {
  var searchInfo = _ref4.searchInfo,
      id = _ref4.id,
      onSelect = _ref4.onSelect,
      onSubmit = _ref4.onSubmit,
      onChange = _ref4.onChange,
      onBlur = _ref4.onBlur,
      onFocus = _ref4.onFocus,
      onToggleDropdown = _ref4.onToggleDropdown,
      isLimitedSearch = _ref4.isLimitedSearch;

  if (!searchInfo) {
    return null;
  } // NOTE: the narrow search button below toggles the display of the narrow search dropdown.
  // That dropdown can also be hidden by "clicking away." However, clicking this button when
  // it's display should be considered a "click away" otherwise we'll have a case where the
  // dropdown will be hidden by "clicking away" and then show because we just clicked the
  // button to toggle it back on. So the "ignore-react-onclickoutside" class is a special
  // class that causes it not to be classified as a "click away".


  return React.createElement("div", {
    className: "eds-global-header__search eds-text--right",
    "data-spec": "global-header-search"
  }, React.createElement("span", {
    className: "eds-global-header__narrow-search-button-wrapper eds-show-down-mn eds-l-pad-right-2 ignore-react-onclickoutside"
  }, React.createElement(Button, {
    style: "none",
    onClick: onToggleDropdown,
    "data-spec": "global-search-narrow-search-button"
  }, React.createElement(Icon, {
    type: React.createElement(MagnifyingGlassChunkySvg, null),
    size: "small",
    color: "grey-700"
  }))), React.createElement(GlobalHeaderSearchForm, {
    searchInfo: searchInfo,
    id: id,
    className: "eds-global-header__search-autocomplete eds-show-up-md",
    onSelect: onSelect,
    onSubmit: onSubmit,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    isLimitedSearch: isLimitedSearch
  }));
};

var GlobalHeaderMenuIcon = function GlobalHeaderMenuIcon(_ref5) {
  var iconType = _ref5.iconType,
      _ref5$iconColor = _ref5.iconColor,
      iconColor = _ref5$iconColor === void 0 ? 'grey-700' : _ref5$iconColor;
  return React.createElement(Icon, {
    type: iconType,
    size: "small",
    color: iconColor,
    "data-spec": "global-header-menu-icon"
  });
};

var GlobalHeaderQuickLinks = function GlobalHeaderQuickLinks(_ref6) {
  var links = _ref6.links,
      useNarrowBreakpoint = _ref6.useNarrowBreakpoint;

  if (!links) {
    return null;
  }

  var linkComponents = links.map(function (_ref7) {
    var url = _ref7.url,
        content = _ref7.content,
        narrowIconType = _ref7.narrowIconType,
        narrowIconColor = _ref7.narrowIconColor,
        isActive = _ref7.isActive,
        type = _ref7.type,
        onClick = _ref7.onClick,
        restProps = _objectWithoutProperties(_ref7, ["url", "content", "narrowIconType", "narrowIconColor", "isActive", "type", "onClick"]);

    var narrowIcon;
    var Component = 'a';
    var linkProps = restProps;
    var quickLinkWrapperClassName = classNames('eds-global-header__quick-link', {
      // If the link collapses into an icon on narrow screens,
      // we want to make sure we're not hiding it
      'eds-global-header__quick-link--narrow': narrowIconType,
      // If the links not an icon and there's no reference to use a 'narrower' breakpoint
      // we want to show the link at the medium breakpoint
      'eds-show-up-md': !narrowIconType && !useNarrowBreakpoint,
      // If the links not an icon and we're using a 'narrower' breakpoint
      // we want to show the link at the medium narrow breakpoint
      'eds-show-up-mn': !narrowIconType && useNarrowBreakpoint,
      // If link is active apply this class
      'eds-global-header__quick-link--active': isActive
    }); // we only show the icon when the screen is "narrow". When `useNarrowBreakpoint`
    // is `true` we want it to be even "narrower".

    var narrowIconClassName = "eds-show-down-".concat(useNarrowBreakpoint ? 'sw' : 'mn'); // we only show the content when the screen is *not* "narrow". When `useNarrowBreakpoint`
    // is `true` we want it to persist to a "narrower" point.

    var contentClassName = "eds-show-up-".concat(useNarrowBreakpoint ? 'mn' : 'md');

    if (narrowIconType) {
      narrowIcon = React.createElement(GlobalHeaderMenuIcon, {
        iconType: narrowIconType,
        iconColor: narrowIconColor
      });
    }

    if (type === ROUTER_LINK) {
      Component = Link;
      linkProps.to = url;
    } else {
      linkProps.href = url;
    }

    return React.createElement(Component, _extends({}, linkProps, {
      key: url,
      className: quickLinkWrapperClassName,
      "data-spec": "global-header-quick-link",
      onClick: onClick
    }), React.createElement("span", {
      className: narrowIconClassName
    }, narrowIcon), React.createElement("span", {
      className: contentClassName
    }, content));
  });
  return React.createElement("div", {
    className: "eds-global-header__quick-links",
    "data-spec": "global-header-quick-links"
  }, linkComponents);
};

var GlobalHeaderCallToAction = function GlobalHeaderCallToAction(_ref8) {
  var linkInfo = _ref8.linkInfo,
      useNarrowBreakpoint = _ref8.useNarrowBreakpoint;
  var component = null;

  if (linkInfo) {
    var url = linkInfo.url,
        content = linkInfo.content,
        linkProps = _objectWithoutProperties(linkInfo, ["url", "content"]);

    var className = classNames('eds-global-header__call-to-action', {
      'eds-show-up-md': !useNarrowBreakpoint,
      'eds-show-up-mn': useNarrowBreakpoint
    });
    component = React.createElement("span", {
      className: className
    }, React.createElement("a", _extends({}, linkProps, {
      href: url,
      "data-spec": "global-header-call-to-action",
      className: "eds-global-header__call-to-action__link"
    }), content));
  }

  return component;
};

var GlobalHeaderDropdownMenuImage = function GlobalHeaderDropdownMenuImage(_ref9) {
  var imageUrl = _ref9.imageUrl;
  return React.createElement("span", {
    className: "eds-global-header__menu-profile-image--container"
  }, React.createElement("img", {
    className: "eds-global-header__menu-profile-image",
    src: imageUrl,
    alt: gettext('Profile Image'),
    "data-spec": "global-header-menu-profile-image"
  }), React.createElement("div", {
    className: "eds-global-header__menu-profile-image--border"
  }));
};

var GlobalHeaderDropdownMenuNarrowOnlyIcon = function GlobalHeaderDropdownMenuNarrowOnlyIcon(_ref10) {
  var narrowIconType = _ref10.narrowIconType,
      narrowIconColor = _ref10.narrowIconColor;
  return React.createElement("span", {
    className: "eds-global-header__menu-icon eds-show-down-mn"
  }, React.createElement(GlobalHeaderMenuIcon, {
    iconType: narrowIconType,
    iconColor: narrowIconColor
  }));
};

var GlobalHeaderDropdownMenuIcon = function GlobalHeaderDropdownMenuIcon(_ref11) {
  var iconType = _ref11.iconType,
      narrowIconType = _ref11.narrowIconType,
      iconColor = _ref11.iconColor,
      narrowIconColor = _ref11.narrowIconColor;
  var className = classNames('eds-global-header__menu-icon', {
    'eds-show-up-md': narrowIconType
  });
  var icon = null;

  if (narrowIconType) {
    icon = React.createElement("span", {
      className: "eds-global-header__menu-icon eds-show-down-mn",
      "data-spec": "global-header-menu-icon-narrow-container"
    }, React.createElement(GlobalHeaderMenuIcon, {
      iconType: narrowIconType,
      iconColor: narrowIconColor
    }));
  }

  return React.createElement("span", null, React.createElement("span", {
    className: className,
    "data-spec": "global-header-menu-icon-container"
  }, React.createElement(GlobalHeaderMenuIcon, {
    iconType: iconType,
    iconColor: iconColor
  })), icon);
};

var GlobalHeaderDropdownMenuAvatar = function GlobalHeaderDropdownMenuAvatar(_ref12) {
  var avatarProps = _ref12.avatarProps;
  return React.createElement(Avatar, _extends({
    size: "small"
  }, avatarProps));
};

var GlobalHeaderUserAvatar = function GlobalHeaderUserAvatar(menuInfo) {
  var avatarProps = menuInfo.avatarProps,
      imageUrl = menuInfo.imageUrl,
      iconType = menuInfo.iconType,
      narrowIconType = menuInfo.narrowIconType;
  var component = null;
  var helperTypes = {
    avatar: {
      'test': function test() {
        return avatarProps;
      },
      'fn': GlobalHeaderDropdownMenuAvatar
    },
    image: {
      'test': function test() {
        return imageUrl;
      },
      'fn': GlobalHeaderDropdownMenuImage
    },
    icon: {
      'test': function test() {
        return iconType;
      },
      'fn': GlobalHeaderDropdownMenuIcon
    },
    narrowIcon: {
      'test': function test() {
        return !iconType && narrowIconType;
      },
      'fn': GlobalHeaderDropdownMenuNarrowOnlyIcon
    }
  };

  var _getType = function _getType(types) {
    var type = findKey(types, function (value) {
      return value.test();
    });
    var Klass = null;

    if (type) {
      Klass = helperTypes[type].fn;
    }

    return Klass;
  };

  var UserAvatarComponent = _getType(helperTypes);

  if (UserAvatarComponent) {
    component = React.createElement(UserAvatarComponent, menuInfo);
  }

  return component;
};

var DropdownComponentByType = function DropdownComponentByType(_ref13) {
  var menuInfo = _ref13.menuInfo,
      onAdditionalMenuTextItemSelect = _ref13.onAdditionalMenuTextItemSelect,
      additionalProps = _objectWithoutProperties(_ref13, ["menuInfo", "onAdditionalMenuTextItemSelect"]);

  var label = menuInfo.label,
      fallbackUrl = menuInfo.fallbackUrl,
      navItems = menuInfo.navItems,
      textItems = menuInfo.textItems,
      className = menuInfo.className,
      preventMouseOver = menuInfo.preventMouseOver,
      imageUrl = menuInfo.imageUrl,
      iconType = menuInfo.iconType,
      narrowIconType = menuInfo.narrowIconType;
  var menuContainerClassName = classNames(className, 'eds-global-header__menu');
  var hasImageOrIcon = imageUrl || iconType || narrowIconType;
  return React.createElement("div", {
    className: menuContainerClassName
  }, React.createElement(DropdownMenu, _extends({}, additionalProps, {
    fallbackUrl: fallbackUrl,
    navItems: navItems,
    textItems: textItems,
    dropdownAlign: ALIGN_RIGHT,
    preventMouseOver: preventMouseOver,
    onTextItemSelect: onAdditionalMenuTextItemSelect,
    hideDropIconWhenNarrow: !!hasImageOrIcon
  }), React.createElement(GlobalHeaderUserAvatar, menuInfo), React.createElement("span", {
    className: "eds-global-header__menu-label",
    "data-spec": "global-header-menu-label"
  }, label)));
};

var DropdownButton = function DropdownButton(_ref14) {
  var item = _ref14.item,
      iconType = _ref14.iconType,
      narrowIconType = _ref14.narrowIconType,
      iconColor = _ref14.iconColor,
      narrowIconColor = _ref14.narrowIconColor,
      onClick = _ref14.onClick;
  var component = null;
  var value = item.value,
      content = item.content;
  var icon = null;
  var narrowIcon = null;

  if (narrowIconType) {
    narrowIcon = React.createElement("div", {
      className: "eds-global-header__menu-icon eds-show-down-mn"
    }, React.createElement(GlobalHeaderMenuIcon, {
      iconType: narrowIconType,
      iconColor: narrowIconColor
    }));
  }

  if (iconType) {
    icon = React.createElement("span", {
      className: "eds-global-header__menu-icon eds-show-up-mn"
    }, React.createElement(GlobalHeaderMenuIcon, {
      iconType: iconType,
      iconColor: iconColor
    }));
  }

  component = React.createElement("div", {
    className: "eds-global-header__menu-button"
  }, React.createElement(Button, {
    style: "none",
    onClick: onClick.bind(null, value, 0),
    "data-spec": "global-header-dropdown-button"
  }, icon, narrowIcon, React.createElement("span", {
    className: "eds-global-header__menu-label"
  }, content)));
  return component;
};

var GlobalHeaderMenu = function GlobalHeaderMenu(_ref15) {
  var menuInfo = _ref15.menuInfo,
      onAdditionalMenuTextItemSelect = _ref15.onAdditionalMenuTextItemSelect,
      additionalProps = _objectWithoutProperties(_ref15, ["menuInfo", "onAdditionalMenuTextItemSelect"]);

  var component = null;

  if (menuInfo) {
    var _menuInfo$textItems = menuInfo.textItems,
        textItems = _menuInfo$textItems === void 0 ? [] : _menuInfo$textItems,
        iconType = menuInfo.iconType,
        iconColor = menuInfo.iconColor,
        narrowIconType = menuInfo.narrowIconType,
        narrowIconColor = menuInfo.narrowIconColor;
    var hasOnlyOneItem = textItems.length === 1;

    if (hasOnlyOneItem) {
      var item = textItems[0];
      component = React.createElement(DropdownButton, {
        item: item,
        iconType: iconType,
        iconColor: iconColor,
        narrowIconType: narrowIconType,
        narrowIconColor: narrowIconColor,
        onClick: onAdditionalMenuTextItemSelect
      });
    } else {
      component = React.createElement(DropdownComponentByType, _extends({}, additionalProps, {
        menuInfo: menuInfo,
        onAdditionalMenuTextItemSelect: onAdditionalMenuTextItemSelect
      }));
    }
  }

  return component;
};

var GlobalHeaderMenus = function GlobalHeaderMenus(_ref16) {
  var userMenuInfo = _ref16.userMenuInfo,
      additionalMenus = _ref16.additionalMenus,
      onAdditionalMenuTextItemSelect = _ref16.onAdditionalMenuTextItemSelect,
      useNarrowBreakpoint = _ref16.useNarrowBreakpoint;
  var menus = [];
  var component = null;
  var className = classNames('eds-global-header__menus', {
    'eds-show-up-md': !useNarrowBreakpoint,
    'eds-show-up-mn': useNarrowBreakpoint
  });

  if (!isEmpty(additionalMenus)) {
    menus = additionalMenus.map(function (menuInfo) {
      return React.createElement(GlobalHeaderMenu, {
        key: menuInfo.label,
        menuInfo: menuInfo,
        onAdditionalMenuTextItemSelect: onAdditionalMenuTextItemSelect
      });
    });
  }

  if (userMenuInfo) {
    var userMenuInfoWithIcon = _objectSpread({
      iconType: React.createElement(UserChunkySvg, null),
      className: 'eds-global-header__user-menu'
    }, userMenuInfo);

    menus = [].concat(_toConsumableArray(menus), [React.createElement(GlobalHeaderMenu, {
      key: "userMenu",
      menuInfo: userMenuInfoWithIcon,
      "data-spec": "global-header-user-menu"
    })]);
  }

  if (!isEmpty(menus)) {
    component = React.createElement("div", {
      className: className,
      "data-spec": "global-header-menus"
    }, menus);
  }

  return component;
};

var GlobalHeaderMajorSection = function GlobalHeaderMajorSection(_ref17) {
  var id = _ref17.id,
      logoInfo = _ref17.logoInfo,
      searchInfo = _ref17.searchInfo,
      quickLinks = _ref17.quickLinks,
      onSearchSelect = _ref17.onSearchSelect,
      onSearchSubmit = _ref17.onSearchSubmit,
      onSearchChange = _ref17.onSearchChange,
      onSearchBlur = _ref17.onSearchBlur,
      onSearchFocus = _ref17.onSearchFocus,
      onToggleDropdown = _ref17.onToggleDropdown,
      isLimitedSearch = _ref17.isLimitedSearch,
      useNarrowBreakpoint = _ref17.useNarrowBreakpoint;
  return React.createElement("div", {
    className: "eds-global-header__major",
    "data-spec": "global-header-major"
  }, React.createElement(GlobalHeaderLogo, {
    info: logoInfo
  }), React.createElement(GlobalHeaderSearch, {
    id: "".concat(id, "-search"),
    searchInfo: searchInfo,
    onSelect: onSearchSelect,
    onSubmit: onSearchSubmit,
    onChange: onSearchChange,
    onBlur: onSearchBlur,
    onFocus: onSearchFocus,
    onToggleDropdown: onToggleDropdown,
    isLimitedSearch: isLimitedSearch
  }), React.createElement(GlobalHeaderQuickLinks, {
    links: quickLinks,
    useNarrowBreakpoint: useNarrowBreakpoint
  }));
};

var GlobalHeaderMinorSection = function GlobalHeaderMinorSection(_ref18) {
  var userMenuInfo = _ref18.userMenuInfo,
      additionalMenus = _ref18.additionalMenus,
      nonUserQuickLinks = _ref18.nonUserQuickLinks,
      callToActionInfo = _ref18.callToActionInfo,
      narrowMenuInfo = _ref18.narrowMenuInfo,
      onAdditionalMenuTextItemSelect = _ref18.onAdditionalMenuTextItemSelect,
      useNarrowBreakpoint = _ref18.useNarrowBreakpoint;
  var narrowMenu;
  var narrowAdditionalMenus;

  if (narrowMenuInfo) {
    var className = classNames('eds-global-header__narrow-menu', {
      'eds-show-down-sw': useNarrowBreakpoint,
      'eds-show-down-mn': !useNarrowBreakpoint
    });
    narrowMenu = narrowMenuInfo.map(function (menuInfo) {
      return React.createElement("span", {
        key: menuInfo.label,
        className: className
      }, React.createElement(GlobalHeaderMenu, {
        menuInfo: menuInfo,
        "data-spec": "global-header-narrow-menu"
      }));
    });
  }

  if (!isEmpty(additionalMenus)) {
    narrowAdditionalMenus = additionalMenus.map(function (menuInfo) {
      if (menuInfo.narrowIconType) {
        return React.createElement("div", {
          className: "eds-global-header__narrow-menu eds-show-down-mn",
          key: menuInfo.label
        }, React.createElement(GlobalHeaderMenu, {
          menuInfo: menuInfo,
          onAdditionalMenuTextItemSelect: onAdditionalMenuTextItemSelect
        }));
      }

      return null;
    });
  }

  return React.createElement("div", {
    className: "eds-global-header__minor",
    "data-spec": "global-header-minor"
  }, React.createElement(GlobalHeaderCallToAction, {
    linkInfo: callToActionInfo,
    useNarrowBreakpoint: useNarrowBreakpoint
  }), React.createElement(GlobalHeaderMenus, {
    additionalMenus: additionalMenus,
    onAdditionalMenuTextItemSelect: onAdditionalMenuTextItemSelect,
    useNarrowBreakpoint: useNarrowBreakpoint
  }), React.createElement(GlobalHeaderQuickLinks, {
    links: nonUserQuickLinks,
    useNarrowBreakpoint: useNarrowBreakpoint
  }), React.createElement(GlobalHeaderMenus, {
    userMenuInfo: userMenuInfo,
    useNarrowBreakpoint: useNarrowBreakpoint
  }), narrowAdditionalMenus, narrowMenu);
};

var GlobalHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(GlobalHeader, _React$PureComponent);

  function GlobalHeader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GlobalHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GlobalHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // the search dropdown is shown by clicking a search button that only
      // shows on a narrow screen. The main search autocomplete is hidden
      // when that narrow search button is displayed.
      showSearchDropdown: false
    });

    return _this;
  }

  _createClass(GlobalHeader, [{
    key: "_handleToggleSearchDropdown",
    value: function _handleToggleSearchDropdown() {
      this.setState(function (_ref19) {
        var prevShowSearchDropDown = _ref19.showSearchDropdown;
        return {
          showSearchDropdown: !prevShowSearchDropDown
        };
      });
    }
  }, {
    key: "_handleHideSearchDropdown",
    value: function _handleHideSearchDropdown() {
      this.setState({
        showSearchDropdown: false
      });
    }
  }, {
    key: "_handleOnAdditionalMenuTextItemSelect",
    value: function _handleOnAdditionalMenuTextItemSelect(value, index) {
      if (this.props.onAdditionalMenuTextItemSelect) {
        this.props.onAdditionalMenuTextItemSelect(value, index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          logoInfo = _this$props.logoInfo,
          searchInfo = _this$props.searchInfo,
          quickLinks = _this$props.quickLinks,
          userMenuInfo = _this$props.userMenuInfo,
          additionalMenus = _this$props.additionalMenus,
          nonUserQuickLinks = _this$props.nonUserQuickLinks,
          callToActionInfo = _this$props.callToActionInfo,
          onSearchSelect = _this$props.onSearchSelect,
          onSearchChange = _this$props.onSearchChange,
          onSearchBlur = _this$props.onSearchBlur,
          onSearchFocus = _this$props.onSearchFocus,
          onSearchSubmit = _this$props.onSearchSubmit,
          isLimitedSearch = _this$props.isLimitedSearch,
          useNarrowBreakpoint = _this$props.useNarrowBreakpoint,
          style = _this$props.style;
      var showSearchDropdown = this.state.showSearchDropdown;
      var narrowMenuInfo = getNarrowMenuInfo(userMenuInfo, additionalMenus, nonUserQuickLinks, callToActionInfo, quickLinks, !useNarrowBreakpoint);

      if (narrowMenuInfo && !Array.isArray(narrowMenuInfo)) {
        narrowMenuInfo = [narrowMenuInfo];
      }

      var className = classNames('eds-global-header', {
        'eds-global-header--style-organizer': style === constants.STYLE_ORGANIZER
      });
      return React.createElement("header", {
        id: id,
        className: className,
        "data-spec": "global-header"
      }, React.createElement("a", {
        className: "eds-global-header__skip-links eds-is-hidden-accessible",
        href: "#skip-heading"
      }, gettext('Skip Main Navigation')), React.createElement("div", {
        className: "eds-global-header__main",
        "data-role": "header"
      }, React.createElement(GlobalHeaderMajorSection, {
        id: id,
        logoInfo: logoInfo,
        searchInfo: searchInfo,
        quickLinks: quickLinks,
        onSearchSelect: onSearchSelect,
        onSearchSubmit: onSearchSubmit,
        onSearchChange: onSearchChange,
        onSearchBlur: onSearchBlur,
        onSearchFocus: onSearchFocus,
        onToggleDropdown: this._handleToggleSearchDropdown.bind(this),
        isLimitedSearch: isLimitedSearch,
        useNarrowBreakpoint: useNarrowBreakpoint
      }), React.createElement(GlobalHeaderMinorSection, {
        userMenuInfo: userMenuInfo,
        additionalMenus: additionalMenus,
        onAdditionalMenuTextItemSelect: this._handleOnAdditionalMenuTextItemSelect.bind(this),
        nonUserQuickLinks: nonUserQuickLinks,
        callToActionInfo: callToActionInfo,
        narrowMenuInfo: narrowMenuInfo,
        useNarrowBreakpoint: useNarrowBreakpoint
      }), React.createElement(GlobalHeaderSearchDropdown, {
        show: showSearchDropdown,
        id: "".concat(id, "-search-dropdown"),
        searchInfo: searchInfo,
        onHide: this._handleHideSearchDropdown.bind(this),
        onSelect: onSearchSelect,
        onSubmit: onSearchSubmit,
        onChange: onSearchChange,
        onBlur: onSearchBlur,
        onFocus: onSearchFocus,
        isLimitedSearch: isLimitedSearch
      })), React.createElement("span", {
        id: "skip-heading",
        className: "eds-is-hidden-accessible"
      }, gettext('Page Content')));
    }
  }]);

  return GlobalHeader;
}(React.PureComponent);

_defineProperty(GlobalHeader, "propTypes", {
  /**
   * Configuration for the global header logo, including the URL that
   * the logo link navigates to
   */
  logoInfo: PropTypes.shape({
    url: PropTypes.string.isRequired,
    iconType: ICON_TYPE_PROP_TYPE,
    iconColor: COLOR_PROP_TYPE,
    iconTitle: EBPropTypes.translation,
    iconWidth: PropTypes.string,
    iconHeight: PropTypes.string,
    backgroundColor: COLOR_PROP_TYPE,
    shouldUseSpecialWidth: PropTypes.bool
  }).isRequired,

  /**
   * ID of the global header
   */
  id: PropTypes.string,

  /**
   * Configuration for the search field. If omitted, no search field
   * is shown. If suggestions are omitted, a regular text input is
   * displayed.
   */
  searchInfo: PropTypes.shape({
    label: EBPropTypes.translation.isRequired,
    formAction: PropTypes.string,
    fieldName: PropTypes.string,
    query: PropTypes.string,
    suggestions: TEXT_ITEMS_PROP_TYPE,
    formMethod: PropTypes.string
  }),

  /**
   * Configuration for 1 or more "quick links" in the global header
   * that show before the menus (i.e. "Browse events").
   * If omitted or 0, they will not show.
   */
  quickLinks: constants.LINKS_PROP_TYPE,

  /**
   * Configuration for the user dropdown nav menu in the global header.
   */
  userMenuInfo: constants.DROPDOWN_PROP_TYPE,

  /**
   * Configuration for 1 or more additional dropdown nav/text menus in the global header.
   * If omitted or 0, they will not show. On a narrow screen, the menu labels
   * and fallbackUrls will be included in the userMenu if it exists, otherwise
   * in a special default menu. These show before the userMenu
   */
  additionalMenus: PropTypes.arrayOf(constants.DROPDOWN_PROP_TYPE),

  /**
   * Configuration for 1 or more "quick links" in the global header that show after
   * the menus, but only show when the userMenu is undefined (i.e. "Sign Up").
   * If omitted or 0, they will not show.
   */
  nonUserQuickLinks: constants.LINKS_PROP_TYPE,

  /**
   * Configuration for the main "call to action"
   * (i.e. "Create event"). If omitted, it will not show.
   */
  callToActionInfo: constants.LINK_PROP_TYPE,

  /**
   * Callback function invoked when the value of the search input changes.
   * (searchQuery) => { }
   */
  onSearchChange: PropTypes.func,

  /**
   * Callback function invoked when the search input is blurred.
   * (searchQuery) => { }
   */
  onSearchBlur: PropTypes.func,

  /**
   * Callback function invoked when the search input is focused.
   * (searchQuery) => { }
   */
  onSearchFocus: PropTypes.func,

  /**
   * Callback function invoked when a search suggestion is selected.
   * (searchQuery) => { }
   */
  onSearchSelect: PropTypes.func,

  /**
   * Callback function invoked when a search form is submitted (i.e. ENTER is pressed).
   * Default browser for submission is disabled.
   * (searchQuery) => { }
   */
  onSearchSubmit: PropTypes.func,

  /**
   * Whether or not you can **only** pick from the list of search suggestions
   */
  isLimitedSearch: PropTypes.bool,

  /**
   * Callback function invoked when a menu item is selected.
   * (value, index) => { }
   */
  onAdditionalMenuTextItemSelect: PropTypes.func,

  /**
   * For headers with a lot of content and still space for it to fit,
   * narrow breakpoint allows links to persist until 792px.
   */
  useNarrowBreakpoint: PropTypes.bool,

  /**
   * Changes the visual/color scheme of the header
   */
  style: PropTypes.oneOf(constants.STYLES)
});

_defineProperty(GlobalHeader, "defaultProps", {
  id: constants.DEFAULT_ID,
  isLimitedSearch: false,
  useNarrowBreakpoint: false,
  style: constants.STYLE_DEFAULT
});

export { GlobalHeader as default };